import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { IConversation, ImpersonationBroker, IOperationResultNoValue, ITextRecipient } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface Params {
	conversationId: string;
	toNumbers: ITextRecipient[];
}

export const useConversationRemoveContactMutation = ({
	onSuccess,
	onError,
	onSettled,
}: {
	onSuccess?: (data: IConversation, variables: Params) => void;
	onError?: (error: IOperationResultNoValue) => void;
	onSettled?: () => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ conversationId, toNumbers }: Params) => {
			const updatedToNumbers = toNumbers.map(num => ({
				...num,
				contact: null as Api.IPrincipal,
			}));
			return userSession.webServiceHelper.callAsync<IConversation>(
				ImpersonationBroker.composeApiUrl({ urlPath: `conversation/${conversationId}/recipients` }),
				'PUT',
				updatedToNumbers
			);
		},
		onSuccess,
		onError,
		onSettled,
	});
};
